/**
 * Web runtime mirror of the canonical repo theme (theme/brand.js).
 *
 * Tailwind config (a Node file) requires the root theme directly, but CRA's
 * ModuleScopePlugin forbids bundling imports from outside src/, so the runtime
 * tokens we need (gradients for inline styles + Framer Motion presets) are
 * mirrored here. Keep these values in sync with /theme/brand.js.
 */

export const gradients = {
  brand:
    'linear-gradient(95deg, #EC008C 0%, #F7941E 22%, #FFD200 42%, #39B54A 62%, #00AEEF 82%, #662D91 100%)',
  hero: 'linear-gradient(135deg, #0E7CC4 0%, #2E3192 60%, #662D91 100%)',
  ring: 'linear-gradient(145deg, #27A6E9 0%, #0A5C9E 100%)',
  brandStops: ['#EC008C', '#F7941E', '#FFD200', '#39B54A', '#00AEEF', '#662D91'],
};

export const motionTokens = {
  duration: { fast: 0.2, base: 0.4, slow: 0.7 },
  ease: [0.22, 1, 0.36, 1],
  spring: { stiffness: 260, damping: 26, mass: 0.9 },
};

const ease = motionTokens.ease;

/* ---- Framer Motion variants ---- */
export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: motionTokens.duration.slow, ease } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: motionTokens.duration.base, ease } },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.92 },
  show: { opacity: 1, scale: 1, transition: { duration: motionTokens.duration.base, ease } },
};

export const stagger = (delay = 0.08) => ({
  hidden: {},
  show: { transition: { staggerChildren: delay } },
});

export const viewportOnce = { once: true, amount: 0.25 };
